namespace GeniuzPOS.ReportMasterData {
    export class Report_1335Columns {
        static columnsKey = 'ReportMasterData.Report_1335';
    }
}
